import React,{useState,useEffect} from 'react';
import { IoIosArrowDropupCircle } from "react-icons/io";
import { Button, Col, Container, Form, Row } from 'react-bootstrap';

import './Scroll.css';

function Sroll() {

    const [visible, setVisible] = useState(false)
    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300){
          setVisible(true)
        } 
        else if (scrolled <= 300){
          setVisible(false)
        }
      };
      
      const scrollToTop = () =>{
        window.scrollTo({
          top: 0, 
          behavior: 'auto'
          /* you can also use 'auto' behaviour
             in place of 'smooth' */
        });
      };
      
      window.addEventListener('scroll', toggleVisible);
      

    return (
        <div>
            <button onClick={scrollToTop} className='ScrollIcon'>
                <IoIosArrowDropupCircle size='2.5rem'  
                style={{display: visible ? 'inline' : 'none'}} />
            </button>
           
        </div>
    )
}

export default Sroll
